import queryString from 'query-string';
import type { IssueTypeResourceData } from '@atlassian/jira-admin-pages-issue-types-common/src/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource } from '@atlassian/react-resource-router';
import { getIssueTypes } from '../../services/issue-types/main.tsx';

// Used for fetching during SSR
export const issueTypesResource = createResource<IssueTypeResourceData>({
	type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
	getKey: () => 'issue types',
	getData: async ({ query }) => getIssueTypes(queryString.stringify(query)),
});
